import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { content, ROUTES, getLangFromPath, getPageKeyFromPath } from "./content";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const pageKey = getPageKeyFromPath(location.pathname);

  const value = useMemo(() => {
    const otherLang = lang === "es" ? "en" : "es";
    return {
      lang,
      t: content[lang],
      pageKey,
      path: (key) => ROUTES[key][lang],
      switchLangPath: ROUTES[pageKey][otherLang],
      otherLang,
    };
  }, [lang, pageKey]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
